import { Plus, X } from 'lucide-react'
import ColumnInput from './ColumnInput'
import './editors.css'

const DIRECTIONS = ['ASC', 'DESC']
const NULLS_OPTIONS = [
  { value: 'default', label: 'Default' },
  { value: 'first', label: 'First' },
  { value: 'last', label: 'Last' },
]

const EMPTY_SORT = { column: '', direction: 'ASC', nulls: 'default' }

function parseValue(raw) {
  if (!raw) return []
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function SortRowsEditor({ value, onChange, disabled, columns }) {
  const sorts = parseValue(value)

  const emit = (next) => onChange(JSON.stringify(next))

  const updateSort = (idx, key, val) => {
    const updated = [...sorts]
    updated[idx] = { ...updated[idx], [key]: val }
    emit(updated)
  }

  const addSort = () => {
    emit([...sorts, { ...EMPTY_SORT }])
  }

  const removeSort = (idx) => {
    emit(sorts.filter((_, i) => i !== idx))
  }

  return (
    <div>
      {sorts.map((s, idx) => (
        <div key={idx} className="editor-row">
          <span className="editor-row-number">{idx + 1}</span>
          <ColumnInput
            columns={columns}
            value={s.column}
            onChange={(val) => updateSort(idx, 'column', val)}
            placeholder="Column"
            disabled={disabled}
          />
          <select
            className="editor-select"
            value={s.direction || 'ASC'}
            onChange={(e) => updateSort(idx, 'direction', e.target.value)}
            disabled={disabled}
            style={{ minWidth: '65px' }}
          >
            {DIRECTIONS.map((d) => (
              <option key={d} value={d}>{d}</option>
            ))}
          </select>
          <select
            className="editor-select"
            value={s.nulls || 'default'}
            onChange={(e) => updateSort(idx, 'nulls', e.target.value)}
            disabled={disabled}
            style={{ minWidth: '70px' }}
          >
            {NULLS_OPTIONS.map((n) => (
              <option key={n.value} value={n.value}>{n.label}</option>
            ))}
          </select>
          <button
            className="editor-remove-btn"
            onClick={() => removeSort(idx)}
            disabled={disabled}
            title="Remove sort column"
          >
            <X size={12} />
          </button>
        </div>
      ))}

      {sorts.length === 0 && (
        <div className="editor-empty">No sort columns defined</div>
      )}

      <button
        className="editor-add-btn"
        onClick={addSort}
        disabled={disabled}
      >
        <Plus size={12} />
        Add Sort Column
      </button>
    </div>
  )
}

export default SortRowsEditor
